import { GoFlame } from "react-icons/go";

import { FilterTypeEnum } from "@sorcery/db";

import { elementOptions } from "~/utils/filters";
import { FilterSection } from "./FilterSection";

export const ElementFilters = () => {
  return (
    <FilterSection type={FilterTypeEnum.ELEMENT} IconComponent={GoFlame} options={elementOptions} />
  );
};
